<script>
// import Login from "../../pages/app/auth/login.vue";
import { mapGetters, mapState, mapActions } from "vuex";
// import LoadingWare from "../fragments/assets/loadingWare.vue";
// import HeaderAppBar2 from "../fragments/layout/headerAppBar2.vue";
// import WinnerCelebrationPopup from "./WinnerCelebrationPopup.vue";

export default {
  name: "WheelComponent",

  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [String, Number],
      default: "preview",
    },
    isPreview: { type: Boolean, default: false },
  },
  components: {
    // LoadingWare,
    // HeaderAppBar2,
    // Login,
    // WinnerCelebrationPopup,
  },
  data() {
    return {
      showWinnerPopup: false,
      lastPrize: {
        prize: {
          name: "",
          reward_value: "",
        },
      },
      loading: false,
      prizes: [],
      rotation: 90,
      currentSlice: 90,
      isSpinning: false,
      tickerAnim: null,
      serverPrizeId: null,
      serverAngle: null,
      extraSpins: 10,
      baseRotation: 0,
      // متغیر کمکی برای اطمینان از آپدیت شدن صفحه
      forceUpdateKey: 0,
    };
  },

  computed: {
    ...mapState("local", ["loginDialog", "qr_id"]),

    wheelLogoUrl() {
      return this.computedInfo?.logo || this.value?.info?.logo || null;
    },
    dialog: {
      get() {
        return this.loginDialog;
      },
      set(val) {
        this.handleLoginPopup(val);
      },
    },
    computedInfo() {
      return this.value?.info || {};
    },
    computedSelected() {
      return this.prizes?.find(
        (prize) => prize.prize_id === this.serverPrizeId,
      );
    },

    wheelKey() {
      const logoState = this.wheelLogoUrl ? this.wheelLogoUrl : "no-logo";
      const prizesState =
        this.prizes && this.prizes.length > 0
          ? this.prizes
              .map(
                (p, i) => `${p.prize_id || i}-${p.icon ? p.icon : "no-icon"}`,
              )
              .join("|")
          : "empty";

      return `wheel-${logoState}-${prizesState}-${this.forceUpdateKey}`;
    },

    prizeSlice() {
      return this.prizes.length > 0 ? 360 / this.prizes.length : 0;
    },
    prizeOffset() {
      return this.prizes.length > 0 ? Math.floor(180 / this.prizes.length) : 0;
    },
    spinnerBackground() {
      if (this.prizes.length === 0) return "transparent";
      const gradientParts = this.prizes
        .map(
          ({ color }, i) =>
            `${color || "#fff"} 0 ${
              (100 / this.prizes.length) * (this.prizes.length - i)
            }%`,
        )
        .reverse();

      return `conic-gradient(from -90deg, ${gradientParts.join(", ")})`;
    },
    spinnerStyles() {
      return {
        background: this.spinnerBackground,
        "--rotate": this.rotation,
      };
    },
  },

  mounted() {
    this.getWheel();
    this.generateRandomExtraSpins();
    // اجبار به رندر مجدد با یک تاخیر کوتاه برای زمانی که دیتا از API دیرتر می‌رسد
    setTimeout(() => {
      this.forceUpdateKey += 1;
    }, 500);
  },

  beforeDestroy() {
    if (this.tickerAnim) {
      cancelAnimationFrame(this.tickerAnim);
    }
  },
  created() {
    this.updateQrId(this.id);
    this.updateQrType("wheel");
    this.$root.$on("wheel-prizes-updated", () => {
      this.getWheel();
    });
  },
  destroyed() {
    this.$root.$off("wheel-prizes-updated");
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal) return;

        let segments = [];
        if (Array.isArray(newVal.prizes)) segments = newVal.prizes;
        else if (newVal.prizes?.items) segments = newVal.prizes.items;

        if (segments && segments.length > 0) {
          this.prizes = segments.map((item, index) => ({
            ...item,
            prize_id: item.id || item.prize_id || index,
          }));
        } else {
          this.prizes = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions("local", [
      "updateQrId",
      "updateQrInfo",
      "handleLoginPopup",
      "updateQrType",
    ]),
    previewSpin() {
      if (this.prizes.length === 0) return;

      const randomIndex = Math.floor(Math.random() * this.prizes.length);
      const fakePrize = this.prizes[randomIndex];

      this.setServerPrize({
        prize_id: fakePrize.prize_id,
        angle: randomIndex * this.prizeSlice + this.prizeOffset,
        reward_text: fakePrize.reward_text || "شما برنده شدید!",
        prize_name: fakePrize.name,
      });

      this.lastPrize = {
        prize: {
          name: fakePrize.name,
          reward_value: fakePrize.reward_text || "جایزه ویژه در پیش‌نمایش",
        },
      };

      this.$nextTick(() => {
        this.spinWheelWithMomentum();

        setTimeout(() => {
          this.$emit("prize-selected", fakePrize);
        }, 5000);
      });
    },
    onWheelFinished(prizeData) {
      this.lastPrize = prizeData;
      this.showWinnerPopup = true;
    },

    spinertia(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    runTickerAnimation() {
      const spinner = document.querySelector(".spinner");
      const ticker = document.querySelector(".ticker");

      if (!spinner || !ticker) return;

      const styles = window.getComputedStyle(spinner);
      const values = styles.transform.split("(")[1]?.split(")")[0]?.split(",");

      if (!values) return;

      const a = values[0];
      const b = values[1];
      let rad = Math.atan2(b, a);

      if (rad < 0) rad += 2 * Math.PI;

      const angle = Math.round(rad * (180 / Math.PI));
      const slice = Math.floor(angle / this.prizeSlice);

      if (this.currentSlice !== slice) {
        ticker.style.animation = "none";
        setTimeout(() => {
          ticker.style.animation = null;
        }, 10);
        this.currentSlice = slice;
      }

      this.tickerAnim = requestAnimationFrame(this.runTickerAnimation);
    },

    selectPrize(prizeId = null) {
      let selected;

      if (prizeId !== null) {
        selected = this.prizes.findIndex((item) => item.prize_id === prizeId);
      } else {
        selected = Math.floor(this.rotation / this.prizeSlice);
      }

      const prizeNodes = document.querySelectorAll(".prize");

      prizeNodes.forEach((prize) => prize.classList.remove("selected"));

      if (prizeNodes[selected]) {
        prizeNodes[selected].classList.add("selected");
        this.$emit("prize-selected", this.prizes[selected]);
      }
    },

    generateRandomExtraSpins(min = 5, max = 25) {
      this.extraSpins = Math.floor(Math.random() * (max - min) + min);
    },

    setServerPrize(apiResponse) {
      this.serverPrizeId = apiResponse.prize_id;
      this.serverAngle = apiResponse.angle;
      const index = this.prizes.findIndex(
        (item) => item.prize_id === apiResponse.prize_id,
      );
      if (index !== -1) {
        this.prizes[index].reward_text = apiResponse.reward_text;
      }
    },

    spinWheel() {
      const wheel = document.querySelector(".deal-wheel");
      const spinner = wheel.querySelector(".spinner");
      const ticker = wheel.querySelector(".ticker");

      if (!spinner || !ticker || !wheel) return;

      this.isSpinning = true;

      let totalRotation;
      if (this.serverAngle !== null) {
        totalRotation = 360 * this.extraSpins + this.serverAngle;
      } else {
        totalRotation =
          360 * this.extraSpins +
          Math.floor(Math.random() * 360 + this.spinertia(2000, 5000));
      }

      this.rotation = totalRotation;

      const prizeNodes = document.querySelectorAll(".prize");
      prizeNodes.forEach((prize) => prize.classList.remove("selected"));

      wheel.classList.add("is-spinning");
      spinner.style.setProperty("--rotate", this.rotation);
      ticker.style.animation = "none";

      this.runTickerAnimation();

      const onTransitionEnd = () => {
        spinner.removeEventListener("transitionend", onTransitionEnd);
        this.handleSpinEnd();
      };

      spinner.addEventListener("transitionend", onTransitionEnd);
    },

    spinWheelWithMomentum() {
      const wheel = document.querySelector(".deal-wheel");
      const spinner = wheel.querySelector(".spinner");
      const ticker = wheel.querySelector(".ticker");

      if (!spinner || !ticker || !wheel) return;

      this.isSpinning = true;

      const targetAngle =
        this.serverAngle !== null
          ? this.serverAngle + 90
          : Math.floor(Math.random() * 360) + 90;

      const totalRotation = 360 * this.extraSpins + targetAngle;

      this.rotation = totalRotation;

      const prizeNodes = document.querySelectorAll(".prize");
      prizeNodes.forEach((prize) => prize.classList.remove("selected"));

      wheel.classList.add("is-spinning");

      spinner.style.transition = `transform ${
        4 + this.extraSpins * 0.5
      }s cubic-bezier(0.1, 0.8, 0.3, 1)`;
      spinner.style.setProperty("--rotate", this.rotation);
      ticker.style.animation = "none";

      this.runTickerAnimation();

      const onTransitionEnd = () => {
        spinner.removeEventListener("transitionend", onTransitionEnd);
        this.handleSpinEnd();
        spinner.style.transition = "";
      };

      spinner.addEventListener("transitionend", onTransitionEnd);
    },

    handleSpinEnd() {
      if (this.tickerAnim) {
        cancelAnimationFrame(this.tickerAnim);
      }

      const wheel = document.querySelector(".deal-wheel");
      const spinner = wheel.querySelector(".spinner");

      this.rotation %= 360;

      if (this.serverPrizeId !== null) {
        this.selectPrize(this.serverPrizeId);
      } else {
        this.selectPrize();
      }

      if (wheel) wheel.classList.remove("is-spinning");
      if (spinner) spinner.style.setProperty("--rotate", this.rotation);

      this.isSpinning = false;
      this.generateRandomExtraSpins();
    },

    spinWheelWithAPI() {
      if (this.isPreview || this.id === "preview-mode") {
        this.previewSpin();
        return;
      }

      try {
        this.serverPrizeId = null;
        this.serverAngle = null;
        this.loading = true;

        this.$api
          .post(`/wheels/spin/${this.id}`)
          .then(({ data }) => {
            this.setServerPrize({ ...data.data });

            this.lastPrize = {
              prize: {
                name: data.data.prize_name || "جایزه ویژه",
                reward_value: data.data.reward_text || "",
              },
            };

            this.$nextTick(() => {
              this.spinWheelWithMomentum();

              this.$once("prize-selected", () => {
                this.showWinnerPopup = true;
              });
            });
          })
          .catch(({ response }) => {
            this.$toast.clear();
            this.$toast.error(response?.data?.message || "خطایی رخ داده است");
          })
          .finally(() => (this.loading = false));
      } catch (error) {
        this.spinWheel();
      }
    },

    getWheel() {
      if (
        this.id !== "preview-mode" &&
        this.id !== null &&
        this.id !== undefined
      ) {
        this.$api.get(`/wheels/show/${this.id}`).then(({ data }) => {
          this.prizes =
            data.data?.segments?.map((item, index) => {
              return {
                ...item,
                prize_id: item.id || index,
              };
            }) || [];
        });
      }
    },
  },
};
</script>

<template>
  <v-app>
    <div
      :style="{ backgroundColor: computedInfo.background_color }"
      class="deal-wrapper"
    >
      <div class="w-100 px-4 py-4 ma-0">
        <v-card-title class="text-center justify-center">
          {{ computedInfo.name }}
        </v-card-title>

        <v-divider class="my-0 mb-1 mx-4 pa-0" />
        <v-card-subtitle class="pa-0 ma-0 text-center justify-center">
          {{ computedInfo.subtitle }}
        </v-card-subtitle>
      </div>

      <!-- مهم: کلید :key به تگ مادر (deal-wheel) منتقل شد تا با هر تغییری کل ساختار گردونه و لوگو همزمان از نو با دقت رندر شوند -->
      <div class="deal-wheel" :key="wheelKey">
        <ul :style="spinnerStyles" class="spinner">
          <li
            v-for="(prize, i) in prizes"
            :key="prize.prize_id || i"
            class="prize"
            :data-reaction="prize.reaction || ''"
            :style="{ '--rotate': `${prizeSlice * i * -1 - prizeOffset}deg` }"
          >
            <!-- اگر آیکون نبود چیزی رندر نمی‌شود، اگر بود حتماً رندر می‌شود -->
            <img v-if="prize.icon" :src="prize.icon" class="img" />
            <span class="text">{{ prize.name }}</span>
          </li>
        </ul>
        <div class="ticker"></div>

        <!-- عکس لوگو وسط چرخ -->
        <div class="wheel-center-logo" v-if="wheelLogoUrl">
          <img :src="wheelLogoUrl" class="center-logo-img" />
        </div>
      </div>

      <div class="btn-spin py-4">
        <v-btn
          :disabled="isSpinning"
          :loading="loading"
          class="bg-info text-white"
          depressed
          min-width="160"
          rounded
          x-large
          @click="spinWheelWithAPI()"
        >
          <v-icon right>mdi-cursor-pointer</v-icon>
          !بچرخون
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<style>
* {
  box-sizing: border-box;
}

.deal-wrapper {
  direction: ltr !important;
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  box-sizing: border-box;
  /* overflow: hidden; */
}

.deal-wheel {
  --size: clamp(160px, 60vmin, 280px);
  --lg-hs: 0 3%;
  --lg-stop: 50%;
  --lg: linear-gradient(
    hsl(var(--lg-hs) 0%) 0 var(--lg-stop),
    hsl(var(--lg-hs) 20%) var(--lg-stop) 100%
  );
  position: relative;
  display: grid;
  align-items: center;
  grid-template-areas:
    "spinner"
    "trigger";
  font-size: calc(var(--size) / 25);
  text-align: center !important;
  width: var(--size);
}

.deal-wheel > * {
  grid-area: spinner;
}

.deal-wheel .btn-spin {
  grid-area: trigger;
  justify-self: center;
}

.deal-wheel::before {
  content: "";
  position: absolute;
  inset: -23px;
  background: linear-gradient(90deg, #c9a96e 0%, #f4e4bc 100%);
  z-index: 0;
  border-radius: 50%;
  transform-style: preserve-3d;
  transform: translateZ(-1px);
}

.deal-wheel::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #c9a96e, #f4e4bc);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 20 !important;
  box-shadow: 0 0 20px rgba(201, 169, 110, 0.9),
    0 0 40px rgba(201, 169, 110, 0.6), 0 0 60px rgba(201, 169, 110, 0.3);
}

.spinner {
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: 0 0 15px 4px rgba(0, 0, 0, 0.4) inset,
    0 0 15px 4px rgba(0, 0, 0, 0.2);
  position: relative;
  display: grid;
  align-items: center;
  grid-template-areas: "spinner";
  width: var(--size);
  height: var(--size);
  transform: rotate(calc(var(--rotate, 25) * 1deg));
  border-radius: 50%;
}

.spinner * {
  grid-area: spinner;
  z-index: 1;
  position: relative;
}

.spinner:before {
  animation: none !important;
  border: none !important;
}

.prize {
  display: flex;
  align-items: center;
  padding: 0 clamp(160px/6, 60vmin/6, 280px/6) 0
    clamp(160px/20, 60vmin/20, 280px/20);
  width: 50%;
  height: 50%;
  transform-origin: center right;
  transform: rotate(var(--rotate));
  user-select: none;
  position: relative;
}

.prize::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  top: 55%;
  left: -15px;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50%;
  box-shadow: -1px 0 1px 1px rgba(0, 0, 0, 0.4) inset,
    0 0 1px 1px rgba(0, 0, 0, 0.2);
}

.prize::before {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  top: 45%;
  left: -16px;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50%;
  box-shadow: -1px 0 1px 1px rgba(0, 0, 0, 0.4) inset,
    0 0 1px 1px rgba(0, 0, 0, 0.2);
}

.prize .img {
  width: 40px !important;
  height: 40px !important;
  object-fit: contain !important;
  margin-inline-end: 8px !important;
  border-radius: 50% !important;
  flex-shrink: 0 !important;
  z-index: 5 !important;
}

.ticker {
  position: absolute;
  top: -9%;
  left: 47%;
  transform: translateX(-50%) rotate(90deg);
  width: calc(var(--size) / 10);
  height: calc(var(--size) / 20);
  background: var(--lg);
  z-index: 10;
  clip-path: polygon(20% 0, 100% 50%, 20% 100%, 0% 50%);
  transform-origin: center bottom;
}

.is-spinning .spinner {
  transition: transform 8s cubic-bezier(0.1, -0.01, 0, 1);
}

.is-spinning .ticker {
  animation: tick 700ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes tick {
  40% {
    transform: rotate(-12deg);
  }
}

.prize.selected .text {
  color: white;
  animation: selected 800ms ease;
}

.text {
  font-size: calc(var(--size) / 30);
  font-weight: 200;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

@keyframes selected {
  25% {
    transform: scale(1.25);
    text-shadow: 1vmin 1vmin 0 hsla(0 0% 0% / 0.1);
  }
  40% {
    transform: scale(0.92);
    text-shadow: 0 0 0 hsla(0 0% 0% / 0.2);
  }
  60% {
    transform: scale(1.02);
    text-shadow: 0.5vmin 0.5vmin 0 hsla(0 0% 0% / 0.1);
  }
  75% {
    transform: scale(0.98);
  }
  85% {
    transform: scale(1);
  }
}

.btn-spin .v-btn {
  background: linear-gradient(
    135deg,
    #c9a96e 0%,
    #f4e4bc 50%,
    #c9a96e 100%
  ) !important;
  color: #1a1a2e !important;
  font-weight: 700 !important;
  letter-spacing: 1px;
  box-shadow: 0 8px 25px rgba(201, 169, 110, 0.5) !important;
  text-transform: none !important;
}

.btn-spin .v-btn:disabled {
  background: linear-gradient(
    135deg,
    #b89a5a 0%,
    #e0d0a8 50%,
    #b89a5a 100%
  ) !important;
  opacity: 0.9;
}

.deal-wheel.super-spin .spinner {
  transition: transform 8s cubic-bezier(0.17, 0.67, 0.12, 0.99);
}

.wheel-center-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 76px;
  height: 76px;
  border-radius: 50%;
  z-index: 30 !important;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.95);
  border: 4px solid #c9a96e;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3),
    inset 0 0 10px rgba(255, 255, 255, 0.5);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

.is-spinning .wheel-center-logo {
  animation: logoGlow 2s ease-in-out infinite alternate;
}

@keyframes logoGlow {
  from {
    box-shadow: 0 0 20px rgba(249, 215, 28, 0.6);
  }
  to {
    box-shadow: 0 0 40px rgba(255, 223, 0, 0.8), 0 0 60px rgba(255, 200, 0, 0.5);
  }
}
</style>
